import React from 'react';
import './MadeWithBadge.css';

interface MadeWithBadgeProps {
  // 'floating' anchors to a corner with absolute positioning (for embeds / map surfaces).
  // 'inline' flows with surrounding content (for share pages / detail views).
  variant?: 'floating' | 'inline';
}

const PLATFORM_URL = 'https://mapofprojects.com';
const LOGO_SRC = '/images/landing/default_logo.png';

const MadeWithBadge: React.FC<MadeWithBadgeProps> = ({ variant = 'floating' }) => {
  return (
    <a
      href={PLATFORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`made-with-badge made-with-badge--${variant}`}
      aria-label="Made with Map of Projects"
    >
      <img src={LOGO_SRC} alt="" className="made-with-badge__logo" />
      <span className="made-with-badge__text">
        Made with <strong>Map of Projects</strong>
      </span>
    </a>
  );
};

export default MadeWithBadge;
